import React, { useEffect, useRef, useState } from 'react';
import "../../Assets/CSS/Styles.scss";
import "../../Assets/CSS/Home.scss";
import onboardicon from "../../Assets/Images/Icons2/HowItWorksSection/onboard.png"
import automateicon from "../../Assets/Images/Icons2/HowItWorksSection/automated-process.png"
import analysisicon from "../../Assets/Images/Icons2/HowItWorksSection/analyze1.png";
import { Link } from 'react-router-dom';
const HowItWorks = () => {

    const [visibleCards, setVisibleCards] = useState([false, false, false]);
    const sectionRef = useRef(null);

    useEffect(() => {
        const currentRef = sectionRef.current;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    visibleCards.forEach((_, index) => {
                        setTimeout(() => {
                            setVisibleCards((prev) => {
                                const newState = [...prev];
                                newState[index] = true;
                                return newState;
                            });
                        }, index * 300);
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [visibleCards]);




    return (
        <>
            <div>
                <div className="mx-auto px-20 py-8">
                    {/* Header Section */}
                    <div className="text-center mb-2">
                        <h2 className="Headers font-ui">How It Works</h2>
                        <p className="subHeads font-ui">
                            Transform your institution in three simple steps with our proven implementation
                            methodology
                        </p>
                    </div>

                    <div className="relative py-12 px-4 sm:px-6 lg:px-8">
                        {/* Connecting Line - Behind Cards */}
                        <div className="hidden md:flex absolute top-1/2 left-0 right-0 h-0 z-0 px-10">
                            <div className="flex-1 border-t-4 border-solid border-amber-400 mx-16"></div>
                        </div>

                        {/* Cards Section */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 relative z-10">
                            {/* Step 1 Card */}
                            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
                                {/* Circular Icon - Positioned at top center overlapping the border */}
                                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 border-2 border-white shadow-md">
                                        <img
                                            src={onboardicon}
                                            alt="Onboard icon"
                                            className="w-9 h-9 object-contain"
                                        />
                                    </div>
                                </div>

                                <div className="pt-8"> {/* Added padding to account for absolute icon */}
                                    <div className="flex items-center justify-center mb-4">
                                        <div className="stepCounter font-ui font-bold">
                                            Step 1
                                        </div>
                                    </div>
                                    <h3 className="solutionTitle font-heading font-heading-bold text-center">Onboard</h3>
                                    <p className="step_p font-ui">
                                        Quick setup and data migration with our
                                        expert team guiding you through every
                                        step.
                                    </p>
                                    <p className="step_subp">
                                        Complete setup in just ___ weeks with
                                        dedicated support and training for your staff.
                                    </p>
                                </div>
                            </div>

                            {/* Step 2 Card */}
                            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
                                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 border-2 border-white shadow-md">
                                        <img
                                            src={automateicon}
                                            alt="Automate icon"
                                            className="w-9 h-9 object-contain"
                                        />
                                    </div>
                                </div>

                                <div className="pt-8">
                                    <div className="flex items-center justify-center mb-4">
                                        <div className="stepCounter font-ui font-bold">
                                            Step 2
                                        </div>
                                    </div>
                                    <h3 className="solutionTitle font-heading font-heading-bold text-center">Automate</h3>
                                    <p className="step_p font-ui">
                                        Streamline all administrative processes
                                        from admissions to fee collection
                                        automatically.
                                    </p>
                                    <p className="step_subp">
                                        Reduce manual work by 80% with intelligent
                                        automation and workflow management.
                                    </p>
                                </div>
                            </div>

                            {/* Step 3 Card */}
                            <div className="bg-white rounded-xl shadow-md p-6 cardborder relative transition-all duration-300 hover:scale-105 hover:shadow-lg ">
                                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 border-2 border-white shadow-md">
                                        <img
                                            src={analysisicon}
                                            alt="Analyze icon"
                                            className="w-9 h-9 object-contain"
                                        />
                                    </div>
                                </div>

                                <div className="pt-8">
                                    <div className="flex items-center justify-center mb-4">
                                        <div className="stepCounter font-ui font-bold">
                                            Step 3
                                        </div>
                                    </div>
                                    <h3 className="solutionTitle font-heading font-heading-bold text-center">Analyze</h3>
                                    <p className="step_p font-ui">
                                        Make data-driven decisions with
                                        comprehensive analytics and real-time
                                        insights.
                                    </p>
                                    <p className="step_subp">
                                        Access 50+ pre-built reports and custom
                                        dashboards for strategic planning.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                   <div className="flex justify-center mt-2">
                        <Link to = '/freedemo'><button className="mt-2 text-[14px] font-bold demo-button bg-[#F59E0B]  hover:bg-[#f3b541] font-ui ">
                            Start Your Transformation Today
                        </button></Link>
                    </div>

                </div>
            </div>
        </>
    );
};

export default HowItWorks;